import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const OneOfMatcher: FieldMatcher = {
  name: 'oneOf',
  displayName: 'One of',
  hasEditor: true,
  options: {
    chipFormatter: (value: string) => `: ${value}`,
  },
  editorOptions: {
    selectionOptions: [],
  },
};